<template>
  <b-row>
    <b-col
      cols="12"
      class="mb-2"
    >
      <h3 class="mb-0">
        ผู้ประกอบธุรกิจ (ผู้ถูกร้องทุกข์)
      </h3>
      <span class="text-danger">**โปรดระบุข้อมูลอย่างน้อย 1 ผู้ประกอบการ</span>



      <b-card
        title="ค้นหาผู้ประกอบธุรกิจ (ผู้ถูกร้องทุกข์)"
        body-border-variant="primary"
        body-class="rounded"
      >
        <b-col class="container text-right mt-n2">
          <b-button
            v-if="this.IsEdit_CompanySearch === true"
            variant="primary"
            @click="
              onBtnCompanySearchClicked({
                compId: '',
                companyDetail: '',
                address: null,
              })
            "
          >
            <feather-icon icon="PlusIcon" class="mr-25" />
            <span>ค้นหาผู้ประกอบธุรกิจ</span>
          </b-button>
          <b-button
            v-if="this.IsEdit_CompanySearch === true && this.ComponentName !== 'ProvincialComplaint'"
            variant="primary"
            class="ml-1"
            @click="
              onBtnCompanyModalClicked(null)
            "
          >
            <feather-icon icon="PlusIcon" class="mr-25" />
            <span>เพิ่มผู้ประกอบธุรกิจ</span>
          </b-button>
        </b-col>
        <b-col cols="12">
          <b-list-group flush>
            <b-list-group-item
              v-for="item in complainantCompany"
              :key="item.compId"
            >
              <CompanySearch
                :company="item"
                :IsEdit_CompanySearch="IsEdit_CompanySearch"
                :IsProvince_CompanySearch="ComponentName === 'ProvincialComplaint'"
                @handle-edit="onBtnCompanyModalEditClicked"
                @handle-delete="onBtnCompanySearchDeleteClicked"
              />
            </b-list-group-item>
          </b-list-group>
        </b-col>
      </b-card>








    </b-col>

    <b-col cols="12">

    


      <!-- <b-col md="12">
        <b-form-group
          label="ผู้ประกอบธุรกิจ (ผู้ถูกร้องทุกข์)"
          label-for="entrepreneur"
        >
          <b-row>
            <vue-autosuggest
              :v-model="company.name"
              :value="company.name"
              :suggestions="filteredOptions"
              :limit="limit"
              :input-props="inputProps"
              class="col-12"
              @selected="onSelected"
              @input="onInputChange"
              :get-suggestion-value="getSuggestionValue"
            >
              <template slot-scope="{ suggestion }">
                <span class="my-suggestion-item">{{
                  suggestion.item.label
                }}</span>
              </template>
            </vue-autosuggest>
          </b-row>
        </b-form-group>
      </b-col>

      <b-col md="12">
        <b-form-group
          label="ที่อยู่/รายละเอียดเพิ่มเติม ผู้ประกอบธุรกิจ (ผู้ถูกร้องทุกข์)"
          label-for="entrepreneurDetail"
        >
          <span class="text-danger">**โปรดระบุข้อมูลอย่างละเอียด เพื่อความรวดเร็วในการดำเนินการของเจ้าหน้าที่</span>
          <b-form-textarea
            :readonly="IsReadOnly?'':readonly"
            id="entrepreneurDetail"
            v-model="company.detail"
            placeholder="กรุณากรอก ที่อยู่/รายละเอียดเพิ่มเติม ผู้ประกอบธุรกิจ (ผู้ถูกร้องทุกข์)"
            rows="6"
          />
        </b-form-group>
      </b-col> -->

      <b-col cols="12">
        <hr>
      </b-col>

      <b-col
        cols="12"
        class="mb-2"
      >
        <h3 class="mb-0">
          รายละเอียดเรื่องร้องทุกข์
        </h3>
      </b-col>

      <b-col md="12">
        <b-form-group
          label=""
          label-for="complaintDetail"
        >
          <span class="text-danger">**โปรดระบุข้อมูลอย่างละเอียดมากที่สุดโดยให้เนื้อหาครอบคลุมถึงสถานที่ซื้อ หรือรับบริการ / มูลเหตุจูงใจที่ซื้อ และวิธีชำระเงิน</span>
          <b-form-textarea
            :readonly="IsReadOnly?'':readonly"
            id="complaintDetail"
            v-model="company.complaintDetail"
            placeholder="กรุณากรอก รายละเอียดเรื่องร้องทุกข์"
            rows="12"
          />
        </b-form-group>
      </b-col>
      <b-col cols="12">
        <hr>
      </b-col>

    </b-col>

  </b-row>

</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BForm,
  BButton,
  BCard,
  BFormTextarea,
  BListGroupItem,
  BListGroup,
} from 'bootstrap-vue'
import { VueAutosuggest } from "vue-autosuggest";
import * as companyStore from "@/store/api/company/index.js";
// import { required, email } from '@validations'
import Personal from './Personal.vue'

import CompanySearch from "../../components/CompanySearch.vue";

export default {
  components: {
    VueAutosuggest,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BCard,
    BFormTextarea,
    Personal,
    CompanySearch,
    BListGroupItem,
    BListGroup,
  },
  props: {
    IsReadOnly: Boolean,
    company: {
      type: Object,
    },
    complainantCompany: [],
    IsEdit_CompanySearch: Boolean,
    ComponentName: '',
  },
  data() {
    return {
      entrepreneur: '',
      entrepreneurDetail: '',
      complaintDetail: '',
      datasuggest: [],
      filteredOptions: [],
      inputProps: {
        id: "companyName",
        class: "form-control",
        placeholder: "ผู้ประกอบธุรกิจ (ผู้ถูกร้องทุกข์)",
      },
      limit: 10,
    }
  },
  created() {
    // `this` points to the vm instance
    console.log(`a is: ${this.a}`)
  },
  methods: {
    onBtnCompanySearchDeleteClicked(passData) {
      console.log('onDeletedBtnClicked')
      this.$emit("onBtnCompanySearchDeleteClicked", passData);
    },
    onBtnCompanySearchClicked(passData) {
      console.log('onEditBtnClicked')
      this.$emit("onBtnCompanySearchClicked", passData);
      //this.onBtnCompanyModalClicked(passData.compId)
    },
    onBtnCompanyModalEditClicked(passData) {
      this.onBtnCompanyModalClicked(passData.compId)
    },
    onBtnCompanyModalClicked(id) {
      console.log('onBtnCompanyModalClicked', id)
      this.$emit('company-digital-modal-clicked', id)
    },
    onSelected(option) {
      this.$emit('company-name-change', option.item.label)
    },
    onInputChange(text) {
      const _this = this;

      if (text === "" || text === undefined) {
        return;
      }

      if (text.length < 3) {
        return;
      }

      this.$emit('company-name-change', text)

      companyStore
        .getByName(text)
        .then((response) => {
          console.log("response", response);
          /* Full control over filtering. Maybe fetch from API?! Up to you!!! */
          const filteredCompany = response.data.data.slice(0, this.limit);
          _this.filteredOptions = [
            {
              data: filteredCompany,
            },
          ];

          console.log("_this", _this.filteredOptions);
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    getSuggestionValue(suggestion) {
      return suggestion.item.label;
    },
  },
}

</script>

 <style lang="scss" >
 @import '@core/scss/vue/libs/vue-autosuggest.scss';
</style>
